import { FC } from 'react';
import { InlineNotification } from '@carbon/react';
import { format0 } from 'utils/number';
import type { ProcessStatus, StartProcessResponse } from '../types';
import { ProcessProgress } from '../shared';

// The stacked status banners for an address run: a dismissable error, the
// generation / combine / reversal progress bars, a terminal-generation notice,
// and the count of groups a finished reversal couldn't undo.
export const AddressRunBanners: FC<{
  error: string | null;
  onClearError: () => void;
  clustering: boolean;
  clusterStatus: ProcessStatus | null;
  generationFailed: boolean;
  mergeProc: StartProcessResponse | null;
  mergeStatus: ProcessStatus | null;
  reverseProc: StartProcessResponse | null;
  reverseStatus: ProcessStatus | null;
  refusedCount: number;
  onClearRefused: () => void;
}> = ({
  error,
  onClearError,
  clustering,
  clusterStatus,
  generationFailed,
  mergeProc,
  mergeStatus,
  reverseProc,
  reverseStatus,
  refusedCount,
  onClearRefused,
}) => (
  <>
    {error && (
      <InlineNotification
        kind="error"
        title="Error"
        subtitle={error}
        onClose={onClearError}
      />
    )}

    {clustering && (
      <ProcessProgress label="Generating groups" status={clusterStatus} />
    )}
    {generationFailed && (
      <InlineNotification
        kind="error"
        lowContrast
        hideCloseButton
        title="Generation failed"
        subtitle="This run couldn’t finish generating — start a new run to try again."
      />
    )}
    {mergeProc && (
      <ProcessProgress label="Combining addresses" status={mergeStatus} />
    )}
    {reverseProc && (
      <ProcessProgress label="Reversing combines" status={reverseStatus} />
    )}
    {refusedCount > 0 && (
      <InlineNotification
        kind="warning"
        title="Reversal incomplete"
        subtitle={`${format0(refusedCount)} group${
          refusedCount === 1 ? '' : 's'
        } could not be reversed; each shows its reason under its status.`}
        onClose={onClearRefused}
      />
    )}
  </>
);
